<template>
	<!-- header -->
	<header id="header">
		<div class="hInner header_main subHeader">
			<div class="logoWrap">
				<div class="logo"><router-link to="/"></router-link></div>
			</div>
			<div v-if="!route.path.includes('lost_idpw')" class="login"><router-link to="/login">로그인</router-link></div>
		</div>
	</header>
</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const router = useRouter();
const route = useRoute();

if (globaljs.getIsLogin()) {
	router.push('/');
}
</script>